// extracted by mini-css-extract-plugin
export default {"root":"ErpText_root__3FvSZ"};